import { MobileCompareVersionsComponent } from './../../compare-versions/compare-versions.component';
import { DTOConversation } from './../../../../api/WickedApiClient';
import { Subject } from 'rxjs';
import { ViewEncapsulation } from '@angular/core';
import { MobileTermsDialogComponent } from './../../terms-dialog/terms-dialog.component';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { DTOConversationMessage } from './../../../api/WickedApiClient';
import { ImageAttachComponent } from './../../../../Components/image-attach/image-attach.component';
import { SendConversationMessageComponent, SendMessageParameters } from './../../../../Components/send-message/send-conversation-message.component';
import { ConversationService } from './../../../../Services/conversationService';
import { MainService } from 'src/app/Services/service.service';
import { Component, Output, EventEmitter, ViewChild, Input, Inject, OnInit } from '@angular/core';
import { removeEmojis } from '../../../../Helpers/EmojiHelper';

@Component({
  selector: 'vng-chat-textinput-bar',
  templateUrl: './textinput-bar.component.html',
  styleUrls: ['./textinput-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TextinputBarComponent extends SendConversationMessageComponent { 
  public messageForm: FormGroup;
  public restartImagesCount:Subject<any> = new Subject();

  @ViewChild("attachImage", { static: true }) imageAttachComponent: ImageAttachComponent;

  @Output() submitInitialMessage = new EventEmitter<TextinputBarComponent>();
  @Output() reloadMessages = new EventEmitter<DTOConversation>();

  @Input() public newConversationAdvId;
  @Input() public nickVisible: boolean = false;
  @Input() public acceptTermsEnable: boolean = false;
  newConv :boolean = false;

  constructor( private mainService: MainService, private conversationService: ConversationService, private fb: FormBuilder, public matDialog: MatDialog) {
    super(mainService, null);
  }
  public textMessage: string = '';

  ngOnInit(){
    if (this.currentConversation) {
      this.service.advService.getAdvertisementData(this.currentConversation.advertisementId).then(advGet => {
        let advertisement = advGet.adveristments[0];
        
        if(advertisement && advertisement.userId == this.service.userService.getUserId() && advertisement.images.length > 0) this.advImagesCount = advertisement.images.length;
      });
    }

    if(this.newConversationAdvId){
      this.newConv = true;
    }
    this.messageForm = this.fb.group({
      messagecontent: [null, Validators.required],
      nickname: [null, this.nickVisible ? Validators.required : null],
      termsaccept: [false, Validators.required],
    });
  }

  public showTermsDialog(event) {
    event.preventDefault();
    let item = this.matDialog.open(MobileTermsDialogComponent, {
        width: '1000%',
        maxHeight: '100%',
        height: "82vh",
        panelClass: "TermsDialogComponent-panel",
        data: {
            isPopup: true
        }
    });
    item.componentInstance.isPopup = true;
    return false;
  }

  showCompareVersions() {
    let item = this.matDialog.open(MobileCompareVersionsComponent, {
      width: "80%",
      height: "810px",
      panelClass: "CompareVersionsComponent-panel",
      data: {
        isPopup: true,
        title: "Upgrade To Premium to send unlimited pictures"
      }
    })
    item.componentInstance.isPopup = true;
  }

  onCheckChange(e){
    this.messageForm.patchValue({
      termsaccept: e.checked
    });
  }

  private controlNames: { name: string, title: string }[] = [
    { name: 'nickname', title: 'Nick' },
    { name: 'messagecontent', title: 'Message content' },
    { name: 'termsaccept', title: "Terms Accept" }
  ];

  private getInvalidFields(): string[] {
    const result = this.controlNames.map(control => {
      return { controlItem: control, control: this.messageForm.controls[control.name] }
    }).filter(c => c.control != null && !c.control.valid);
    return result.map(c => c.controlItem.title);
  }

  showMaxAttachmentsExceeded() {
    this.showCompareVersions();
  }

  updateMessage(text: string) {
    this.textMessage = text;
  }

  clear() {
    this.textMessage = '';
    this.imageAttachComponent.clear();
    this.restartImagesCount.next(0);
  }

  get nick(): string {
    if (this.messageForm.controls["nickname"].value == null) {
      return "";
    }
    return this.messageForm.controls["nickname"].value;
  }

  set nick(value: string) {
    if (!this.isSpecialUser && !this.PremiumAdvertisementMessages) {
      value = removeEmojis(value);
    }
    this.messageForm.controls["nickname"].setValue(value);
  }
  //TODO typ dla conversationId zwracane sa dwa
  sendMessage(textMessage: string, conversationId){

    if(( this.isNotFirstMessage && this.imagesIsUploaded) || this.messageForm.valid){
      this.conversationMessageContent = textMessage.trim();
      if(textMessage.trim().length < 4000){
        if(!this.newConv){
          this.nick = this.currentConversation!!.senderNick;
          const messageParams = this.prepareMessageParams();
          this.submitStart();
          this.conversationService.sendMessageToExistingConversation(
            this.mainService.userService.getUserId(), 
            messageParams.content,
            this.currentConversation!!.conversationId,
            messageParams.images).then(result => {
              this.conversationService.getConversation(conversationId).then(conversation => {
                this.submitFinished();
                let thanksInfo = this.mainService.showInformation("Your message has been sent");
                setTimeout(() => {
                  thanksInfo.dismiss();
                  this.reloadMessages.emit(conversation);
                  this.clear();
                }, 1000);
              }); 
            }
            ).catch(
              err => {
                this.mainService.showError(err);
                this.submitFinished();
              }
            )
        }else{
          this.submitInitialMessage.emit(this);
        }
      }else{
        this.service.showError("The maximum length of the message is 4000 characters");
      }
    }else {
      this.mainService.showError("Some fields are invalid, fill them properly: " + this.getInvalidFields().join(","));
      return false;
    }
  }

}